import * as Yup from 'yup';

export interface InfantRoadToHealthModel {
  weightAtBirth?: string;
  lengthAtBirth?: string;
  height?: string;
  roadToHealthBook?: string;
  notRoadToHealthBook?: boolean;
}

export const initialInfantRoadToHealthValues: InfantRoadToHealthModel = {
  weightAtBirth: '',
  lengthAtBirth: '',
  roadToHealthBook: '',
  notRoadToHealthBook: false,
};

export const infantRoadToHealthModelSchema = Yup.object().shape({
  weightAtBirth: Yup.string()
    .required('Please enter a value between 500g and 7000g.')
    .test(
      'is-valid-weight',
      'Please enter a value between 500g and 7000g.',
      (val: any) => {
        if (!val) return false;

        const cleanValue = val.toString().replaceAll(',', '.');
        const num = parseFloat(cleanValue);

        return !isNaN(num) && num >= 500 && num <= 7000;
      }
    )
    .typeError('Please enter a value between 500g and 7000g.'),

  lengthAtBirth: Yup.string()
    .required('Please enter a value between 25cm and 130cm.')
    .test(
      'is-valid-length',
      'Please enter a value between 25cm and 130cm.',
      (val: any) => {
        if (!val) return false;

        const cleanValue = val.toString().replaceAll(',', '.');
        const num = parseFloat(cleanValue);

        return !isNaN(num) && num >= 25 && num <= 130;
      }
    )
    .typeError('Please enter a value between 25cm and 130cm.'),

  roadToHealthBook: Yup.string(),
  notRoadToHealthBook: Yup.boolean(),
});
